// The upstream journeys endpoint declares no pagination, so the three list
// endpoints cap their response at this many results (upstream.py's
// JOURNEYS_LIST_CAP) — server-side search (upstream.py) is what makes the
// cap safe.
export const JOURNEYS_LIST_CAP = 500;
